<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${tab.label == 'PENYAKIT' ? 'active' : ''}`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-11">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-1 pt-1 pl-0">
                <button class="btn btn-primary mt-4 btn-block" @click="apply">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <div v-if="loaded">
            <div class="py-4" v-if="hBarData || pieData || barData">
              <div class="row mb-4">
                <div class="col-md-9">
                  <h4 class="py-2">
                    Menampilkan
                    {{
                      formSet.tipe == "all"
                        ? "Semua Kasus"
                        : `Kasus dari ${formSet.tipe.replace(/_/g, " ")}`
                    }}
                    {{
                      formSet.dari
                        ? formSet.sampai
                          ? `periode ${formSet.dari} sampai ${formSet.sampai}:
                    ${total} Kasus`
                          : `sejak ${formSet.dari} sampai saat ini`
                        : formSet.sampai
                        ? `sampai periode ${formSet.sampai}`
                        : ``
                    }}
                    <!-- periode {{ formSet.dari }} sampai {{ formSet.sampai }} -->
                    :{{ total }} Kasus
                  </h4>
                </div>
                <div class="col-md-3">
                  <a
                    href=""
                    @click="print"
                    class="btn btn-outline-secondary btn-with-icon-left"
                  >
                    <i class="material-symbols-outlined">cloud_download</i>
                    Download Laporan
                  </a>
                </div>
              </div>
              <div class="card">
                <div class="row">
                  <div class="col-md-12 py-4 px-5">
                    <!-- <div
                    class="col-md-6 py-4 px-5"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  > -->
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <h5>Kasus Paling Banyak</h5>
                        <div
                          class="row br-2"
                          v-for="item in mostCases"
                          v-bind:key="item.id"
                        >
                          <div class="col-md-6 text-primary bold">
                            {{ item.desc_short }}
                          </div>
                          <div class="col-md-6">{{ item.total }} Kasus</div>
                        </div>
                        <!-- <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div> -->
                      </div>
                      <div class="col-md-6">
                        <h5>Kasus Paling Sedikit</h5>
                        <div
                          class="row br-2"
                          v-for="item in leastCases"
                          v-bind:key="item.id"
                        >
                          <div class="col-md-6 text-primary bold">
                            {{ item.desc_short }}
                          </div>
                          <div class="col-md-6">{{ item.total }} Kasus</div>
                        </div>
                        <!-- <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div>
                        <div class="row br-2">
                          <div class="col-md-6 text-primary bold">
                            Penyakit K
                          </div>
                          <div class="col-md-6">120 Kasus</div>
                        </div> -->
                      </div>
                    </div>
                    <hr />
                    <!-- <h5 class="text-secondary mb-3">Berdasarkan Umur</h5> -->
                    <div v-if="hBarData" style="position: relative">
                      <horizontal-bar-chart
                        :chart-data="hBarData"
                        :options="{
                          maintainAspectRatio: true,
                          scales: {
                            xAxes: [
                              {
                                ticks: {
                                  beginAtZero: true,
                                },
                              },
                            ],
                          },
                        }"
                      ></horizontal-bar-chart>
                    </div>
                    <div v-else>
                      <EmptyState
                        :data="{
                          img: '/img/chart.svg',
                          title: 'Tidak ada data di sini',
                          content:
                            'Tidak ada grafik pasien berdasarkan usia di sini',
                        }"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-md-6 py-4 px-5">
                    <div>
                      <div class="row">
                        <div class="col-md-8">
                          <FormRow
                            :row="formSelect"
                            @handleChange="(e) => handleChangeSelect(e)"
                          />
                        </div>
                        <div class="col-md-4 pt-1 pl-0">
                          <button
                            class="btn btn-primary mt-4 btn-block"
                            @click="apply"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                      <h5 class="mb-4">
                        Total kasus {{ `Penyakit A` }} : {{ total }} Kasus
                      </h5>
                    </div>
                    <h5 class="text-secondary mb-3">
                      Berdasarkan Jenis Kelamin
                    </h5>
                    <div class="mb-4" v-if="pieData">
                      <doughnut-chart
                        :chart-data="pieData"
                        :styles="chartStyles"
                        :options="{ maintainAspectRatio: false }"
                      ></doughnut-chart>
                    </div>
                    <div class="mb-4" v-else>
                      <EmptyState
                        :data="{
                          img: '/img/chart.svg',
                          title: 'Tidak ada data di sini',
                          content:
                            'Tidak ada grafik pasien berdasarkan jenis kelamin di sini',
                        }"
                      />
                    </div>
                    <h5 class="text-secondary mt-4 mb-3">Berdasarkan Umur</h5>
                    <div class="" v-if="barData" style="position: relative">
                      <bar-chart
                        :chart-data="barData"
                        :styles="chartStyles"
                        :options="{ maintainAspectRatio: false }"
                      ></bar-chart>
                    </div>
                    <div class="" v-else>
                      <EmptyState
                        :data="{
                          img: '/img/chart.svg',
                          title: 'Tidak ada data di sini',
                          content:
                            'Tidak ada grafik pasien berdasarkan usia di sini',
                        }"
                      />
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="py-4" v-else>
              <EmptyState
                :data="{
                  img: '/img/chart.svg',
                  title: 'Tampilkan grafik di sini',
                  content: 'Terapkan filter di atas untuk menampilkan grafik',
                  size: 'medium mb-0',
                }"
              />
            </div>
          </div>
          <Loading v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  tabs,
  filtersPenyakit,
  sort,
  upperTabs,
  singleSelectPenyakit,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Dashboard",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    // DoughnutChart,
    // BarChart,
    HorizontalBarChart,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      chartStyles: { height: "25vw", position: "relative" },
      pieData: null,
      barData: null,
      hBarData: null,
      loaded: true,
      data: data,
      filters: filtersPenyakit,
      formSelect: singleSelectPenyakit,
      sort: sort,
      tabs: tabs,
      upperTabs: upperTabs,
      total: 0,
      mostCases: [],
      leastCases: [],
      formSet: {
        tipe: "rawat_jalan",
        dari: "",
        sampai: "",
      },
      single_select: null,
    };
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
      // this.apply();
    },
    print: function() {
      window.print();
    },
    fillData: async function() {
      this.pieData = {
        labels: ["Laki-laki", "Perempuan"],
        datasets: [
          {
            label: "",
            backgroundColor: ["#097CEB", "#e52e6b"],
            data: [this.getRandomInt(), this.getRandomInt()],
          },
        ],
      };

      this.barData = {
        labels: [
          "<1 Tahun",
          "1-4 Tahun",
          "5 -14 Tahun",
          "15-44 Tahun",
          "45 - 64 Tahun",
          "> 65 Tahun",
        ],
        datasets: [
          {
            label: "Total",
            backgroundColor: "#c42a9d",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Laki-laki",
            backgroundColor: "#097CEB",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Perempuan",
            backgroundColor: "#e52e6b",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
        ],
      };
    },
    apply: async function() {
      //console.log(this.formSet);
      this.loaded = false;
      this.errors = [];
      let params = ``;
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        if (self.formSet[key]) {
          params += `${key}=${self.formSet[key]}&`;
        } else {
          if (key == "dari") {
            params += `${key}=2012-01-01&`;
          } else if (key == "sampai") {
            params += `${key}=${getInputDate()}&`;
          }
        }
      });
      try {
        let result = await this.$store.state.HTTP.get(
          "dashboard/grafik_penyakit?" + params
        );
        if (result.status == "200") {
          //console.log(result);
          this.total = result.data && result.data.total ? result.data.total : 0;
          this.mostCases = result.data.kasus_paling_banyak;
          this.leastCases = result.data.kasus_paling_sedikit;
          // let chartLabels = result.data.horizontal_bar_chart.labels;
          // let chartData = result.data.horizontal_bar_chart.datasets[0].data;
          let kasusPerPerPenyakit = result.data.kasus_per_penyakit;
          //console.log(kasusPerPerPenyakit);
          let labels = [];
          let datasets = [];
          let colors = [
            "#097ceb",
            "#F43D7A",
            "#16a085",
            "#01DBFA5",
            "#DD8811",
            "#600060",
          ];
          if (kasusPerPerPenyakit.length) {
            datasets = kasusPerPerPenyakit[0].bar_chart.labels.map(
              (item, index) => {
                return {
                  label: item,
                  backgroundColor: colors[index % colors.length],
                  data: [],
                };
              }
            );

            labels = kasusPerPerPenyakit.map((item) => {
              datasets.forEach((set, index) => {
                set.data.push(item.bar_chart.datasets[index].data[0]);
              });
              return item.nama;
            });
          }

          this.hBarData = {
            // labels: [
            //   "Penyakit A",
            //   "Penyakit B",
            //   "Penyakit C",
            //   "Penyakit D",
            //   "Penyakit E",
            //   "Penyakit F",
            // ],
            labels: labels,
            datasets: datasets,
            // labels: result.data.horizontal_bar_chart.labels,
            // datasets: [
            //   {
            //     label: "Total",
            //     backgroundColor: "#c42a9d",
            //     data: result.data.horizontal_bar_chart.datasets[0].data,
            //   },
            // ],
          };

          // this.hBarData = result.data.horizontal_bar_chart;
          if (result.data.pie_chart) {
            let pie = result.data.pie_chart;
            this.pieData = {
              labels: pie.labels,
              datasets: [
                {
                  label: "",
                  backgroundColor: ["#097CEB", "#e52e6b"],
                  data: pie.datasets,
                },
              ],
            };
          } else {
            this.pieData = null;
          }
          if (result.data.bar_chart) {
            let bar = result.data.bar_chart;
            this.barData = {
              labels: bar.datasets.map((item) => item.label),
              datasets: [
                {
                  label: "Total",
                  backgroundColor: "#c42a9d",
                  data: bar.datasets.map((item) => item.data[0]),
                },
                {
                  label: "Laki-laki",
                  backgroundColor: "#097CEB",
                  data: bar.datasets.map((item) => item.data[1]),
                },
                {
                  label: "Perempuan",
                  backgroundColor: "#e52e6b",
                  data: bar.datasets.map((item) => item.data[2]),
                },
              ],
            };
          } else {
            this.barData = null;
          }

          this.loaded = true;
        } else {
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    // this.apply();
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
